import Reveal from '@/components/base/Reveal';

const categories = [
  'Restaurant Opportunities',
  'Real Estate & Development',
  'Vendor & Supplier Partnerships',
  'Strategic Collaborations',
];

export default function Partnerships() {
  return (
    <section id="partnerships" className="py-24 md:py-32 px-6 md:px-10 bg-foreground-950">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.35em] text-primary-400">Partnerships</p>
          <h2 className="font-heading text-3xl md:text-5xl mt-6 text-background-50 leading-[1.1]">
            Let&apos;s build something worth coming back to.
          </h2>
          <p className="mt-7 text-background-50/75 leading-relaxed max-w-2xl mx-auto">
            JEDL Restaurants works with property owners, hospitality professionals, vendors, investors, and other
            business partners to create and operate compelling restaurant concepts.
          </p>
          <p className="mt-4 text-background-50/75 leading-relaxed max-w-2xl mx-auto">
            If you&apos;re interested in discussing a restaurant opportunity, potential partnership, property, supplier
            relationship, or another collaboration, we&apos;d like to hear from you.
          </p>

          <div className="mt-10">
            <a
              href="#contact"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              Start a Conversation
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 flex flex-wrap justify-center gap-3">
            {categories.map((c) => (
              <span
                key={c}
                className="whitespace-nowrap text-sm px-4 py-2 border border-background-50/20 text-background-50/70"
              >
                {c}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}